import { pathOr } from 'ramda'

import { ACORNS_HELLO_FLOW, APP_VERSION } from 'app-constants'
import platform from 'components/Trackers/platform'
import { getFunnelName } from 'utils/FlowProvider/utils'
import { getTierPrice } from 'utils/TieredRegistration/utils'

import { getPageViewEvent } from './index'
import { EventData } from './pageAnalytics'

export type TrackEventProps = {
  eventData?: object
  location?: Location
  partner?: object
  flow?: string
}

const trackEvent = (eventName: string, eventProps: TrackEventProps) => {
  if (
    // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
    // If you're here from the future, please resolve this ESLint error!
    // eslint-disable-next-line no-prototype-builtins
    (!window.hasOwnProperty('analytics') || !window.analytics.hasOwnProperty('track')) &&
    !window.DD_LOGS
  ) {
    return false
  }

  const flow = eventProps.flow || window.localStorage.getItem(ACORNS_HELLO_FLOW)
  const funnel = getFunnelName(flow)

  let props = {
    ...eventProps.eventData,
    platform,
    funnel,
    tierPrice: getTierPrice(),
    app_version: APP_VERSION,
  } as any

  /* istanbul ignore else */
  if (eventProps.location && eventProps.location.pathname && !props.screen) {
    let { screen: fromScreen } = getPageViewEvent(eventProps.location, flow) as EventData
    fromScreen = fromScreen || pathOr('unknown', ['pathname'], eventProps.location)
    props = { ...props, fromScreen }
  }
  /* istanbul ignore else */
  if (eventProps.partner) {
    const partnerName = pathOr(null, ['org', 'name'], eventProps.partner)
    props = { ...props, ...{ partner: partnerName } }
  }
  /* istanbul ignore else */
  // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
  // eslint-disable-next-line no-prototype-builtins
  if (window.hasOwnProperty('analytics') && window.analytics.hasOwnProperty('track')) {
    window.analytics.track(eventName, props)
  }
  /* istanbul ignore else */
  if (window.DD_LOGS) {
    window.DD_LOGS.logger.log(eventName, props)
  }

  return true
}

export default trackEvent
